import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";
import { imgSrc } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Reveal delay={index * 0.12} className="h-full">
      <Link
        to={`/products/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group flex flex-col h-full"
      >
        <div className="relative overflow-hidden rounded-[1.75rem] aspect-[4/5] bg-brand-beige shadow-sm group-hover:shadow-2xl group-hover:shadow-brand-deep/20 transition-shadow duration-500">
          <img
            src={imgSrc(product.image)}
            alt={`${product.name} — ${product.category}`}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/85 via-brand-ink/10 to-transparent" />
          <span className="absolute top-4 left-4 bg-brand-gold text-brand-deep text-[11px] font-bold px-3 py-1.5 rounded-full tracking-wide">
            {product.pack_size || "25 kg"} Pack
          </span>
          <span className="absolute top-4 right-4 bg-white/90 backdrop-blur text-brand-deep text-[11px] font-bold px-3 py-1.5 rounded-full tracking-wide">
            {product.crop}
          </span>
          <div className="absolute bottom-0 inset-x-0 p-6 flex items-end justify-between">
            <div>
              <h3 className="font-display text-2xl font-extrabold text-white tracking-tight">{product.name}</h3>
              <p className="text-brand-wheat text-xs font-semibold tracking-wider uppercase mt-1">{product.category}</p>
            </div>
            <span className="w-11 h-11 rounded-full bg-brand-gold text-brand-deep flex items-center justify-center shrink-0 transition-transform duration-500 group-hover:rotate-45">
              <ArrowUpRight className="w-5 h-5" />
            </span>
          </div>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-brand-charcoal/65 line-clamp-2">{product.short_description}</p>
        <span className="mt-3 text-sm font-bold text-brand-deep inline-flex items-center gap-1.5 group-hover:gap-3 transition-all">
          View Product <ArrowUpRight className="w-4 h-4" />
        </span>
      </Link>
    </Reveal>
  );
}
